export default __webpack_public_path__ + "static/media/bj.57ff1cc9.jpg";